import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	PostProvidersDentalGuide,
	PostProvidersDentalGuideModel,
	PostProvidersDentalGuideParams,
} from 'domain/usecases/private/guide-flow/dental-guide/post-providers';

export class RemotePostProvidersDentalGuide implements PostProvidersDentalGuide {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostProvidersDentalGuideModel>,
	) {}

	async post({
		signal,
		...params
	}: PostProvidersDentalGuideParams): Promise<PostProvidersDentalGuideModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
			signal,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
